import React, { useState } from 'react';
import apiFetch from '../../../../utils/api';
import { useAuth } from '../../../../context/AuthContext';
import './ChangePassword.css';

function ChangePassword() {
  const { login, user } = useAuth();
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [status, setStatus] = useState({ message: '', error: false, loading: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ message: '', error: false, loading: true });

    if (formData.newPassword !== formData.confirmPassword) {
      setStatus({ message: 'New passwords do not match.', error: true, loading: false });
      return;
    }

    try {
      const res = await apiFetch('/api/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();

      if (data.success) {
        if (data.token) {
          login(data.token, user);
        }
        setStatus({ message: data.message, error: false, loading: false });
        setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        setStatus({ message: data.message, error: true, loading: false });
      }
    } catch (err) {
      setStatus({ message: 'Server error. Please try again.', error: true, loading: false });
    }
  };

  return (
    <div className="cp-wrapper">
      <div className="cp-breadcrumb">
        <span>🏠</span> / Change Password
      </div>
      <h2 className="cp-title">Change Password</h2>

      <div className="cp-card">
        {status.message && (
          <div className={`cp-alert ${status.error ? 'cp-alert--error' : 'cp-alert--success'}`}>
            {status.message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="cp-field">
            <label className="cp-label">Current Password</label>
            <input
              type="password"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              required
              className="cp-input"
              placeholder="Enter current password"
            />
          </div>

          <div className="cp-field">
            <label className="cp-label">New Password</label>
            <input
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              required
              className="cp-input"
              placeholder="Enter new password"
            />
          </div>

          <div className="cp-field">
            <label className="cp-label">Confirm New Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              className="cp-input"
              placeholder="Confirm new password"
            />
          </div>

          <button
            type="submit"
            disabled={status.loading}
            className="cp-submit"
          >
            {status.loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;